module.exports = "\r\n    <ng-content></ng-content>\r\n"